import "./ButtonLoaderSpinner.styles.css";

export const BtnContent = ({
  loading,
  label,
}: {
  loading: boolean;
  label: string;
}) => (
  <span
    style={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: 60,
    }}
  >
    <span style={{ visibility: loading ? "hidden" : "visible" }}>{label}</span>
    {loading && (
      <span
        style={{
          position: "absolute",
          width: 14,
          height: 14,
          border: "2px solid currentColor",
          borderTopColor: "transparent",
          borderRadius: "50%",
          animation: "btn-spin 0.65s linear infinite",
        }}
      />
    )}
  </span>
);
